import script from "./Control.vue?vue&type=script&setup=true&lang=js"
export * from "./Control.vue?vue&type=script&setup=true&lang=js"

import "./Control.vue?vue&type=style&index=0&id=60533e20&lang=scss"
import "./Control.vue?vue&type=style&index=1&id=60533e20&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60533e20"]])

export default __exports__